import ServicesApp from '../Functionality/ServicesApp';
import CustomUserChip from '../../../../components/CustomUserChip';
import {InfoChip} from '../../../../components/buttons/IconButtons';
import { POSITION_MODEL } from '../../../../Helpers/PositionModel';
import { CustomCompactTable } from './../../../../components/CustomCompactTable';
import {DATE_TIME_FORMAT_MODEL, getDateFormat} from "../../../../Apis/functions";
import {Trans} from "react-i18next";
import {CustomSelect} from "../../../../components/CustomSelect";
import React from "react";
import CustomSearch from "../../../../components/SearchSimples/CustomSearch";
import {DAILY_SERVICES_SIZE} from "../Model/Model";

/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */

const Services = ({
    item,
    setItem,
    handleChange,
    option,
    isOnline,
    setIsOnline,
    setBodyForExport,
    modified,
    setModified
}) => {
    const {
        t,
        activeCafeteriaOptions,
        employees,
        onFilter,
        render,
        searchText,
        setSearchText,
        getRowClassName,
        getRowKey,
        handleSearch,
        onReset
    } = ServicesApp({
        isOnline,
        setIsOnline,
        modified,
        setModified,
        option,
        setBodyForExport,
        item,
        setItem,
        handleChange
    });

    return (
        <>
            <div className='row'>
                <div className='col-12 col-md-3 px-0 pl-md-1 pr-md-2'>
                    <CustomSelect
                        id={'slt_s_cafeteria_id'}
                        name={'cafeteriaId'}
                        value={item.cafeteriaId}
                        keyName='id'
                        onChange={onFilter}
                        list={activeCafeteriaOptions}
                        trans={'diner'}
                        label={'lbl_s_cafeteria_id'}
                        required={false}
                    />
                </div>
                <div className={'col-12 col-md-9 px-0 pl-md-2 pr-md-1'}>
                    <CustomSearch id={'txt_s_search'}
                                  label={"search_by_name_email_or_phone"}
                                  value={searchText}
                                  setValue={setSearchText}
                                  onChange={(e) => setSearchText(e.target.value)}
                                  searchFunction={handleSearch}
                                  onReset={onReset}
                    />
                </div>
            </div>
            { employees?.totalElements > 0 &&
                <div className='px-1'>
                    <CustomUserChip
                        className='mt-0 chip-secondary-150-100 justify-content-start d-flex my-3 w-100'
                        name={employees?.totalElements > DAILY_SERVICES_SIZE ? <Trans
                            i18nKey={"daily_service_legend"}
                            values={{
                                total: employees?.totalElements,
                                date: getDateFormat(new Date(), false, DATE_TIME_FORMAT_MODEL.en.monthWithDay),
                                size: DAILY_SERVICES_SIZE
                            }}
                            components={{ bold: <strong /> }}
                        />:<Trans
                            i18nKey={"x_employees_have_been_served_on_x"}
                            values={{
                                total: employees?.totalElements,
                                date: getDateFormat(new Date(), false, DATE_TIME_FORMAT_MODEL.en.monthWithDay),
                            }}
                            components={{ bold: <strong /> }}
                        />}
                        Icon={InfoChip}
                        showAvatar={true}
                        classNameIcon={'icon-color-secondary-700'}
                        variant='large'
                        iconPosition={POSITION_MODEL.LEFT}
                    />
                </div>
            }
            <div className={"px-1 mb-60px"}>
                <CustomCompactTable
                    render={render}
                    data={employees?.content || []}
                    searchElement={item.search}
                    notInformationLegend={t("no_records_available")}
                    getRowClassName={getRowClassName}
                    getRowKey={getRowKey}
                />
            </div>
        </>
    );
};

export default Services;
